const orderPaths = {
  ORDER_STATUS_GRAPH: (venueId) => `status-history/graph/venue/${venueId}`,
  ORDER_STATUS_KPI: (venueId) => `status-history/kpi/venue/${venueId}`,
  ORDER_STATUS_TIMELINE: (orderId) => `${orderId}/status-history/timeline`,
};

export default orderPaths;
